import React from "react";
import { useContent } from "contexts/contentContext/contentContext.js";

const UploaderHeader = () => {
  const { getTextByKey } = useContent();
  return (
    <div className="jm-form-uploader-header">
      <h1>{getTextByKey("select-files-embed-uploader")}</h1>
      <p>{getTextByKey("select-files-embed-uploader-text")}</p>
    </div>
  );
};

export default UploaderHeader;
